import React from 'react';
import { useSelector } from 'react-redux';
import { selectSprayEventTypeIsWeed } from 'services/sprayEventType/selectors';

export interface OwnProps {
    children: React.ReactElement;
    fallback?: React.ReactElement;
}

type Props = OwnProps;

export default function SprayEventTypeWeedGate(
    props: Props
): React.ReactElement | null {
    const { children, fallback } = props;

    const isSprayEventTypeWeed = useSelector(selectSprayEventTypeIsWeed);

    if (!isSprayEventTypeWeed) {
        if (fallback) {
            return fallback;
        }

        return null;
    }

    return children;
}
